function createBasicObserver({ selector, callback, config = {}, debug = false }) {
  if (debug) console.log("[snippet]", "inside createBasicObserver");

  const mergedConfig = {
    root: null,
    rootMargin: "0px",
    threshold: [0],
    once: true,
    ...config,
  };
  let hasTriggered = false;

  if (debug) console.log("[snippet]", "config", mergedConfig);

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          if (debug) console.log("[snippet]", "entry isIntersecting");

          if (mergedConfig.once && hasTriggered) return;

          try {
            callback(entry);
            if (debug) console.log("[snippet]", "Try calling callback");
          } catch (error) {
            if (debug) console.error("[BasicObserver] Callback error:", error);
          }

          hasTriggered = true;
          if (mergedConfig.once) observer.disconnect();
          if (debug) console.log("[snippet]", "disconnected");
        }
      });
    },
    {
      root: null,
      rootMargin: mergedConfig.rootMargin,
      threshold: mergedConfig.threshold,
    },
  );

  observer.observe(document.querySelector(selector));
  if (debug) console.log("[snippet]", "createBasicObserver", "start Observing");
}

module.exports = createBasicObserver;
